<template>
    <a :href="domain + prefix + '/auth/login'"
       class="btn btn--big btn--white-bg nav__button nav__button--content header__button"
    >
        {{ $lang('app.login') }}
    </a>
</template>

<script>
export default {
    name: 'HeaderLoginButtonRender',
    data() {
        return {
            domain: window.laravel.appUrlByLocale,
            prefix: window.laravel.prefix
        }
    }
}
</script>
